const nonAiActionTypes = [
  'QUESTION',
  'COMMAND',
  'NPC_QUESTION',
  'NPC_COMMAND',
];

const nonAiCheckTypes = [
  'QUESTION',
  'COMMAND_COUNT',
  'UNSOLICITED_DIALOGUE',
  'NPC_QUESTION',
  'NPC_COMMAND_COUNT',
  'NPC_UNSOLICITED_DIALOGUE',
];

const nonAiEffectTypes = [
  'QUESTION',
  'COMMAND',
  'ANSWER',
  'UNSOLICITED_DIALOGUE',
  'NPC_QUESTION',
  'NPC_COMMAND',
  'NPC_ANSWER',
  'NPC_UNSOLICITED_DIALOGUE',
];

const aiActionTypes = [
  'AI_QUESTION',
  'NPC_AI_QUESTION',
];

const aiCheckTypes = [
  'AI_QUESTION',
  'NPC_AI_QUESTION',
];

const aiEffectTypes = [
  'AI_UNSOLICITED_DIALOGUE',
  'AI_UPDATE_PROMPT',
  'AI_ANSWER',
  'NPC_AI_UNSOLICITED_DIALOGUE',
  'NPC_AI_UPDATE_PROMPT',
  'NPC_AI_ANSWER',
];

module.exports = {
  nonAiActionTypes,
  nonAiCheckTypes,
  nonAiEffectTypes,
  aiActionTypes,
  aiCheckTypes,
  aiEffectTypes
};